import React from 'react'
import PropTypes from 'prop-types'
import * as blUrls from 'lib/urls'

import { InfoAlert } from 'components/alerts'

class Container extends React.Component {
  static propTypes = {
    showDesktopAlert: PropTypes.bool,
  }

  render() {
    return (
      <div className="mtxl">
        {this.props.showDesktopAlert ? (
          <InfoAlert>
            <p>
              These are instructions to install the share extension on your
              iPhone or iPad.
            </p>
          </InfoAlert>
        ) : null}
        <div className="center-block" style={{ maxWidth: 400 }}>
          {this.props.children}
          <div className="text-center mvxl">
            <a className="small text-uppercase" href={blUrls.contactUsPath}>
              Need Help?
            </a>
          </div>
        </div>
      </div>
    )
  }
}

export default Container
